import { filtersHelper } from '@/utils';
import { departmentModel } from '@/models/api/department.model';

export const phoneExtDepartment = (data) => ({
    uuid: data.uuid,
    name: data.name,
    sequence: data.sequence,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    department: data.department ? departmentModel(data.department) : null,
});